import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=3c4fccde&scoped=true&"
import script from "./Policies.vue?vue&type=script&lang=js&"
export * from "./Policies.vue?vue&type=script&lang=js&"
import style0 from "./Policies.vue?vue&type=style&index=0&id=3c4fccde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fccde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4fccde')) {
      api.createRecord('3c4fccde', component.options)
    } else {
      api.reload('3c4fccde', component.options)
    }
    module.hot.accept("./Policies.vue?vue&type=template&id=3c4fccde&scoped=true&", function () {
      api.rerender('3c4fccde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/settings/Policies.vue"
export default component.exports